import React from 'react';
import { Navbar, Container } from 'react-bootstrap';
import { FaGithub } from 'react-icons/fa'
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <>
      <Navbar className="navbar-dark" >
        <Container>
        <Navbar.Brand>
        <Link to={`/`}>
            Home
        </Link>
        </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Navbar.Text>
              <a href="https://github.com/karishmashuklaa/chic-ui">
                  <FaGithub size={27} color='#2A9FD6' />
                  <span style={{color:'#2A9FD6', marginLeft:'5px'}}> GitHub</span>
                </a>
            </Navbar.Text>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
